import { Subject } from 'rxjs'

import type { User, UserInformation } from './user/types'
import { emitAuthUserUpdate } from './user'

export type AuthStoreEvents =
    | { type: 'LoginRequest', user: undefined | User }
    | { type: 'LoginSuccess', data: UserInformation }
    | { type: 'UserUpdated', data: UserInformation }
    | { type: 'LoginFailure', error: string | Error }
    | { type: 'LogoutRequest' }
    | { type: 'LoggingOut' }
    | { type: 'LoggedOut' };

export type AuthStoreEventType = AuthStoreEvents['type'];
export type AuthStoreEvent<Type extends AuthStoreEventType = AuthStoreEventType> = Extract<AuthStoreEvents, { type: Type }>;

const events = new Subject<AuthStoreEvent>()

export const emitAuthUpdate = (event: AuthStoreEvent) => events.next(event)
export const onAuthUpdated = <T extends AuthStoreEventType>(
    target: T,
    handler: (event: AuthStoreEvent<T>) => unknown,
) => events.subscribe((event) => {
    if (event.type !== target) return
    handler(event as AuthStoreEvent<T>)
})

// This hooks all the events together
events.subscribe((event) => {
    switch (event.type) {
        case 'LoginSuccess':
        case 'UserUpdated':
            return emitAuthUserUpdate(event.data.user)
    }
})
